import moment from 'moment'
import { getAlphanumericDigits, getOnlyDigits } from '../utils/Utils'

export const paginate = {
  limit: value => ['limit', value],
  skip: value => ['skip', value],
  sort: value => ['order', value],
  order: value => ['order', value],
  include: value => ['include', value]
}

export const query = {
  ilike: field => value => [
    `[${field}][ilike]`,
    `%${value.split('').join('%')}%`
  ],
  ilikeWithoutSplit: field => value => [`[${field}][ilike]`, `%${value}%`],
  like: field => value => [`[${field}][like]`, `%${value}%`],
  likeDigits: field => value => [
    `[${field}][like]`,
    `%${getOnlyDigits(value)}%`
  ],
  likeAlphaDigits: field => value => [
    `[${field}][like]`,
    `%${getAlphanumericDigits(value)}%`
  ],
  eq: field => value => [`[${field}]`, `${value}`],
  lte: field => value => [
    `[${field}][lte]`,
    `${moment(value)
      .endOf('day')
      .local()
      .toISOString()}`
  ],
  gte: field => value => [
    `[${field}][gte]`,
    `${moment(value)
      .startOf('day')
      .local()
      .toISOString()}`
  ],
  lteValue: field => value => [`[${field}][lte]`, value],
  gteValue: field => value => [`[${field}][gte]`, value],
  inDay: field => value => [
    [
      `[${field}][between][0]`,
      moment(value)
        .startOf('day')
        .local()
        .toISOString()
    ],
    [
      `[${field}][between][1]`,
      moment(value)
        .endOf('day')
        .local()
        .toISOString()
    ]
  ]
}
